import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Alert from "../../../../Common/Alert";
import Http from "../../../../Common/Http";
import IsLogin from "../../../../Common/IsLogin";
import useAlertFromLocation from "../../../../../hooks/useAlertFromLocation";
import useDeleteData from "../../../../../hooks/useDeleteData";
import ReactDataTable from "../../../../Common/ReactDataTable";

const ViewPlanningForJigger = () => {
  const [planningData, setPlanningData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState("");

  // Fetch all planning data without pagination
  const fetchData = async () => {
    setLoading(true);
    try {
      const [planningRes, roleRes] = await Promise.all([
        Http.get("/planning-list"),
        Http.get("/staff-type-check")
      ]);
      
      setPlanningData(planningRes.data);
      setRole(roleRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteData = useDeleteData(fetchData);
  const alert = useAlertFromLocation();

  const cols = [
    { field: "receipt_no", header: "Short Planning No" },
    { field: "start_date", header: "Start Date" },
    { field: "end_date", header: "End Date" },
    { 
      field: "department.name", 
      header: "Department",
      format: (value) => value || "N/A"
    },
    {
      field: (item) => (
        <div className="text-xs text-nowrap">
          {(role === "planning" ||  role === "jigger" || role === "glazing") && (
            <>
              <Link
                to={`/edit-planning-for-jigger/${item.id}`}
                className="btn btn-primary btn-sm ms-1"
                title="Edit Planning"
              >
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </Link>
            </>
          )}
        </div>
      ),
      header: "Actions",
    },
  ];

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Jigger & Glazing Planning</h5>
          {role === "planning" && (
            <Link 
              to="/create-planning-for-jigger" 
              className="btn btn-primary" 
              title="Create New Planning"
            >
              <i className="fa fa-plus-square mg-r-6"></i> Create New
            </Link>
          )}
        </div>
        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            {loading ? (
              <div className="text-center p-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <ReactDataTable
                cols={cols}
                receiveData={planningData}
                isLoading={loading}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPlanningForJigger;